import axiosConfig from "./axiosConfig";

export interface ArtifactDownloadUrl {
  url: string;
}

const getSiteArtifactDownloadUrl = async (
  authToken: string,
  siteId: string,
  artifactGuid: string
): Promise<ArtifactDownloadUrl> => {
  const { data } = await axiosConfig.get(
    `/site/${siteId}/artifacts/${artifactGuid}`,
    {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    }
  );
  return data;
};

export default getSiteArtifactDownloadUrl;
